import { c as _c } from "react/compiler-runtime";
import clsx from 'clsx';

/**
 * SectionTitle: renders a heading.
 *
 * Props:
 * - title: string|ReactNode
 * - subTitle?: string|ReactNode
 * - as?: heading tag ("h1" | "h2" | "h3" | etc.) — default "h2"
 * - className?: string
 * - subTitleClassName?: string
 */
export default function SectionTitle(t0) {
  const $ = _c(15);
  const {
    title,
    subTitle,
    as: t1,
    className: t2,
    subTitleClassName: t3,
    communityState: t4
  } = t0;
  const as = t1 === undefined ? "h2" : t1;
  const className = t2 === undefined ? "" : t2;
  const subTitleClassName = t3 === undefined ? "" : t3;
  const communityState = t4 === undefined ? "" : t4;
  const Tag = as;
  let t5;
  if ($[0] !== className) {
    t5 = clsx("lg:w-[90%] md:w-[70%] w-[65%] m-0 text-4xl font-extrabold leading-none", className);
    $[0] = className;
    $[1] = t5;
  } else {
    t5 = $[1];
  }
  const cls = t5;
  let t6;
  if ($[2] !== title) {
    t6 = typeof title === "string" ? <span className="block text-[#323232] font-semibold xl:text-[34px] text-[26px] leading-[1em] xl:mb-2 lg:mb-1.5 mb-1">{title}</span> : title;
    $[2] = title;
    $[3] = t6;
  } else {
    t6 = $[3];
  }
  let t7;
  if ($[4] !== communityState || $[5] !== subTitle || $[6] !== subTitleClassName) {
    t7 = subTitle ? <span className={clsx("block 2xl:text-lg lg:text-base md:text-sm text-[13px] lg:text-[#626262] text-[#323232] font-normal leading-[1.1em]", subTitleClassName)}>{subTitle}{communityState ? `, ${communityState}` : ""}</span> : null;
    $[4] = communityState;
    $[5] = subTitle;
    $[6] = subTitleClassName;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  if ($[8] !== t6 || $[9] !== t7) {
    t8 = <>{t6}{t7}</>;
    $[8] = t6;
    $[9] = t7;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  const content = t8;
  let t9;
  if ($[11] !== Tag || $[12] !== cls || $[13] !== content) {
    t9 = <Tag className={cls}>{content}</Tag>;
    $[11] = Tag;
    $[12] = cls;
    $[13] = content;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  return t9;
}